import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=e0176814&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=js&"
export * from "./CustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=e0176814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0176814",
  null
  
)

export default component.exports